import React, { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import SalesTrackerStore from './../../store'
import { MDBCol } from 'mdb-react-ui-kit'
import { UIDropdown, UIInput } from './../../../../components/forms/form-fields'

import './PointOverrides.component.scss'

const getOptions = (Policy, Overrides) => {
  return Overrides.map(Override => ({
    text: `${Override.get('label')}`,
    value: `${Override.id()}`,
    checked: !!(Policy.get('pts_override_id') && parseInt(Policy.get('pts_override_id')) === parseInt(Override.id())),
  }))
}

const renderAmericaChoiceFamily = (Policy, policyIdx, Overrides) => {
  if (Array.isArray(Overrides))
    Overrides = [...Overrides].filter(
      O =>
        `${O.get('carrier_id')}` === `${Policy.get('carrier_id')}` &&
        `${O.get('coverage_id')}` === `${Policy.get('coverage_id')}`
    )

  if (Array.isArray(Overrides) && !!Overrides.length) {
    const O = [...Overrides].shift()
    return (
      <UIDropdown
        optionHeight={37}
        disablePortal
        searchLabel='Search'
        label='Family Selection:'
        name={O.get('field')}
        className='av-point-override'
        options={getOptions(Policy, Overrides)}
        selected={Policy.get('pts_override_id')}
        onChange={evt => {
          const value = parseInt(evt.target.value)
          if (value !== parseInt(Policy.get('pts_override_id'))) Policy.set('pts_override_id', value)
        }}
        required={true}
        value={Policy.get('pts_override_id')}
        rules={{ required: true }}
        showValidity={SalesTrackerStore.showErrors}
        onValidityChange={validity => SalesTrackerStore.setValidity(policyIdx, O.get('field'), validity.isValid)}
      />
    )
  }

  return <></>
}

const renderLifeXAndPSMFamily = (Policy, policyIdx, Overrides) => {
  if (Array.isArray(Overrides))
    Overrides = [...Overrides].filter(O => {
      return (
        `${O.get('carrier_id')}` === `${Policy.get('carrier_id')}` &&
        `${O.get('coverage_id')}` === `${Policy.get('coverage_id')}`
      )
    })

  if (Array.isArray(Overrides) && !!Overrides.length) {
    const O = [...Overrides].shift()
    return (
      <UIDropdown
        optionHeight={37}
        disablePortal
        searchLabel='Search'
        label='Family Selection:'
        name={O.get('field')}
        className='av-point-override'
        options={getOptions(Policy, Overrides)}
        selected={Policy.get('pts_override_id')}
        onChange={evt => {
          const value = parseInt(evt.target.value)
          if (value !== parseInt(Policy.get('pts_override_id'))) Policy.set('pts_override_id', value)
        }}
        required={true}
        value={Policy.get('pts_override_id')}
        rules={{ required: true }}
        showValidity={SalesTrackerStore.showErrors}
        onValidityChange={validity => SalesTrackerStore.setValidity(policyIdx, O.get('field'), validity.isValid)}
      />
    )
  }

  return <></>
}

export default observer(({ Policy, coverageId, carrierId, policyIdx, Fields }) => {
  return [renderLifeXAndPSMFamily(Policy, policyIdx, Fields?.ac_family)].map((inputField, idx) => {
    return (
      <MDBCol key={`pts-override-field-${policyIdx}-${idx}`} size='12' md='6' xl='4' className='av-input-wrapper'>
        {inputField}
      </MDBCol>
    )
  })
})

/*

const renderLifeXNetwork = (Policy, policyIdx, Overrides) => {
  if (!Array.isArray(Overrides)) return null

  const defs = Overrides.filter(
    (o) =>
      o.get('field') === 'lifex_network' &&
      `${o.get('carrier_id')}` === `${Policy.get('carrier_id')}`
  )
  if (!defs.length) return null

  const def = defs[0]

  return (
    <UIInput
      type="text"
      inputMode="decimal"
      pattern="[0-9]*\.?[0-9]*"
      label={def.get('label')}
      name="pts_override_val"
      className="av-point-override"
      value={Policy.get('pts_override_val') ?? ''}
      onChange={(evt) => {
        // allow only digits and dot
        console.log(evt.target.value)
        const cleaned = evt.target.value.replace(/[^0-9.]/g, '')
        const val = cleaned === '' ? null : parseFloat(cleaned)
        console.log(cleaned)
        console.log(val)

        Policy.set('pts_override_val', isNaN(val) ? null : val)
      }}
      required
      showValidity={SalesTrackerStore.showErrors}
      onValidityChange={(validity) =>
        SalesTrackerStore.setValidity(
          policyIdx,
          'pts_override_val',
          validity.isValid
        )
      }
    />
  )
}

export default observer(function PointOverrides({
  Policy,
  coverageId,
  carrierId,
  policyIdx,
  Fields,
}) {
  useEffect(() => {
    let isMounted = true // Flag to track component mount status

    const initializeOverrides = async () => {
      if (coverageId && carrierId && !Fields) {
        try {
          // First await the fetch operation
          await SalesTrackerStore.fetchPointOverrides()

          // Then proceed with the rest of the initialization
          const coverage = SalesTrackerStore.getCoverage(coverageId)
          const carrier = SalesTrackerStore.getCarrier(carrierId)

          if (isMounted) {
            SalesTrackerStore.setPointOverrideOptions(
              coverage,
              carrier,
              policyIdx
            )
          }
        } catch (error) {
          console.error('Failed to initialize override options:', error)
        }
      }
    }

    initializeOverrides()

    return () => {
      isMounted = false // Cleanup function
    }
  }, [coverageId, carrierId, policyIdx, Fields])

  // if (coverageId && carrierId  && !Fields) {
  //   console.log("HERE")
  //   const coverage = SalesTrackerStore.getCoverage(coverageId);
  //   const carrier = SalesTrackerStore.getCarrier(carrierId);
  //   SalesTrackerStore.setPointOverrideOptions(coverage, carrier, policyIdx)
  //   Fields = SalesTrackerStore.PointOverrideFields[policyIdx]
  //   console.log("Fields2" , Fields)

  // }

  let hasLifeX =
    Array.isArray(Fields?.lifex_network) &&
    Fields.lifex_network.some(
      (o) => `${o.get('carrier_id')}` === `${Policy.get('carrier_id')}`
    )
  const inputField = hasLifeX
    ? renderLifeXNetwork(Policy, policyIdx, Fields?.lifex_network)
    : renderAmericaChoiceFamily(Policy, policyIdx, Fields?.ac_family)

  const mdSize = hasLifeX ? '8' : '6'
  const xlSize = hasLifeX ? '6' : '4'

  return (
    <MDBCol
      key={`pts-override-field-${policyIdx}`}
      size="12"
      md={mdSize}
      xl={xlSize}
      className="av-input-wrapper"
    >
      {inputField}
    </MDBCol>
  )
})

*/
